import { leadsRetrieveOptions } from '@crm/api'
import { ChangeFieldStatus } from '@crm/components'
import { FieldsProps } from '@crm/types'
import { useLocales } from '@shared/locales'
import { QueryKey, useQuery } from '@tanstack/react-query'
import { Modal } from 'antd'

import type { ModalProps } from 'antd'

type Props = {
  leads?: number[]
  dataFields?: FieldsProps
  queryKey?: QueryKey
  onClose: () => void
} & ModalProps

export const ChangeStatus = ({ leads, onClose, ...props }: Props) => {
  const { t } = useLocales()

  const leadId = leads?.[0]

  const { data: leadById } = useQuery({
    ...leadsRetrieveOptions({ path: { id: Number(leadId) } }),
    enabled: !!leadId
  })

  return (
    <Modal
      title={t('contacts.change_status')}
      cancelText={t('buttons.cancel')}
      onCancel={onClose}
      footer={null}
      {...props}
    >
      <ChangeFieldStatus
        lead={leadById}
        leadType={leadById?.status?.lead_type?.id}
        onSuccess={onClose}
      />
    </Modal>
  )
}
